import React from "react";
import T from "prop-types";
import { renderIf } from "MODULES/shared/decorators";
import { ADMIN, ACCOUNTING } from "MODULES/users/constants";
import {
  SECOND_EXCHANGE,
  THIRD_EXCHANGE,
  EXCHANGE_CONFIG,
  NOT_EXCHANGED
} from "MODULES/SalesOrders/constants";
import { DropDownItem } from "MODULES/shared/components/DropDown";

const shouldRenderCreateSecondExchange = renderIf(
  ({
    lineItem: {
      cancelled,
      shipped,
      exchange_type: exchangeType,
      exchange_sale: exchangeSale
    },
    currentUser: { role }
  }) =>
    [ADMIN, ACCOUNTING].includes(role) &&
    !cancelled &&
    exchangeSale &&
    (shipped || exchangeType === SECOND_EXCHANGE) &&
    exchangeType !== THIRD_EXCHANGE
);

function CreateSecondExchange({ open, lineItem }) {
  const exchangeType = lineItem.exchange_type;
  const actionText = exchangeType
    ? EXCHANGE_CONFIG[SECOND_EXCHANGE].text
    : EXCHANGE_CONFIG[NOT_EXCHANGED].text;

  return (
    <DropDownItem onClick={() => open(lineItem)}>
      <i className="fa fa-fw fa-refresh" />
      &nbsp;{actionText}
    </DropDownItem>
  );
}

CreateSecondExchange.propTypes = {
  open: T.func.isRequired,
  lineItem: T.shape({})
};

const ConditionalCreateSecondExchange = shouldRenderCreateSecondExchange(
  CreateSecondExchange
);

export default ConditionalCreateSecondExchange;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/CreateSecondExchange/ConditionalCreateSecondExchange.jsx